import React, { Component } from 'react'
import { connect, UserList, Button, UpgradeButton, Fab, MyAvatar, SpinningCircle, T } from 'components'
import { Route, Switch, NavLink } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { POLICY_IDS } from 'common/constants'
import { UPGRADE } from 'common/endpoints'
import { isGold } from 'utils'
import { fetchFlirts, flirtWith, flirtSkip, finishIntro } from 'store/actions'
import StyledFlirt, { FlirtCouple } from './StyledFlirt'
import Match from './Match'

let lastMediaId = null // not bringing much value, added for consistency

const errors = {
  UPGRADE: () => (
    <>
      <T as="h3" label="membership/upgradeToFlirt" />
      <UpgradeButton size="large" to={UPGRADE.page(POLICY_IDS.FLIRT, null, lastMediaId)} />
    </>
  ),
  UPDATE_ACCOUNT: seen => ({ skip }) => (
    <>
      <T as="h3" label={`messages/${seen < 5 ? 'wantToBeInTheRunning' : 'beFair'}`} />
      <div className="buttons">
        <Button color="cta" to="/myprofile" label="actions/uploadPhoto" />
        <Button className="skip" onClick={skip} label="skip" />
      </div>
    </>
  ),
  NO_RESULTS: () => (
    <>
      <T as="h3" label="messages/noMoreMembers" />
      <Button to="/myprofile/matches" color="cta" label="actions/update" />
    </>
  ),
}

const FlirtUpgradeMessage = ({ page }) => {
  const isMutualPage = page == 'mutual'
  const btnLabel = isMutualPage ? 'flirt/enjoy' : 'flirt/talkToThem'
  const btnUrl = '/payment/upgrade?policyId=11' + (isMutualPage ? '1' : '0')

  return (
    <div className="flirt-upgrade-message">
      <div className="upgrade-message">
        <T as="p" label={isMutualPage ? 'flirt/upgradeNowToEnjoy' : 'flirt/luckIsIn'} />
        <Button color="cta" size="large" label={btnLabel} to={btnUrl} />
      </div>
    </div>
  )
}

const WithMeOrMutual = ({ filter }) => {
  const { myProfile } = useSelector(({ myProfile, translations }) => ({
    myProfile,
    flirtExpirationMsg: translations['flirt/flirtExpiration'],
  }))
  const upgraded = isGold(myProfile)
  return (
    <>
      <UserList filter={filter} pagination placeholders={12}>
        {!upgraded && <FlirtUpgradeMessage page={filter} />}
      </UserList>
    </>
  )
}

const FlirtMy = () => {
  const { flirtExpirationMsg, myProfile } = useSelector(({ myProfile, translations }) => ({
    myProfile,
    flirtExpirationMsg: translations['flirt/flirtExpiration'],
  }))
  const upgraded = isGold(myProfile)

  return (
    <>
      <T as="h3" label="flirt/allMembersFlirt" />
      {!upgraded && <p dangerouslySetInnerHTML={{ __html: flirtExpirationMsg }}></p>}
      <UserList filter="myFlirts" pagination placeholders={12} />
    </>
  )
}

const FlirtTabs = () => (
  <div className="flirt-tabs">
    <NavLink to="/flirt/my" activeClassName="active-page">
      <T as="div" className="text" label="sections/flirtMy" />
    </NavLink>
    <NavLink to="/flirt/withMe" activeClassName="active-page">
      <T as="div" className="text" label="sections/flirtWithMe" />
    </NavLink>
    <NavLink to="/flirt/mutual" activeClassName="active-page">
      <T as="div" className="text" label="sections/flirtMutual" />
    </NavLink>
  </div>
)

class Flirt extends Component {
  state = {};

  componentDidMount() {
    this.props.fetchFlirts()
    this.props.finishIntro()
  }

  showPopup = () => {
    const { noPhoto, upgraded, index, skipped, accounts } = this.props

    if (upgraded) {
      return accounts[index] ? false : errors.NO_RESULTS
    }
    const seen = 15 - accounts.length + index
    if ([4, 9].includes(seen) && !skipped && noPhoto) {
      return errors.UPDATE_ACCOUNT(seen)
    }
    return accounts[index] ? false : errors.UPGRADE
  };

  flirt = like => () => {
    const { flirtWith, fetchFlirts, accounts, index, upgraded } = this.props

    lastMediaId = accounts[index].mediaId
    flirtWith(accounts[index], like)

    if (upgraded && index + 1 == accounts.length - 1) {
      fetchFlirts()
    }
  };

  renderContent = Error => {
    if (!this.props.loaded) {
      return <SpinningCircle />
    }
    if (Error) {
      return <Error skip={() => this.props.flirtSkip()} />
    }
    return <Match flirtUser={this.props.accounts[this.props.index]} />
  };

  render() {
    const { error, loaded } = this.props
    const Error = this.showPopup() || (error && errors.UPGRADE)

    return (
      <StyledFlirt>
        <FlirtTabs />
        <Switch>
          <Route
            path="/flirt"
            exact
            component={() => (
              <FlirtCouple className="split">
                <MyAvatar className="half my-half" />
                {loaded && !Error && (
                  <>
                    <Fab name="times" className="cancel" onClick={this.flirt(false)} />
                    <Fab name="heart" className="approve" onClick={this.flirt(true)} />
                  </>
                )}
                <div className="half match-half">{this.renderContent(Error)}</div>
              </FlirtCouple>
            )}
          />
          <Route path="/flirt/my" component={FlirtMy} />
          <Route path="/flirt/withMe" component={() => <WithMeOrMutual filter="withMe" />} />
          <Route path="/flirt/mutual" component={() => <WithMeOrMutual filter="mutual" />} />
        </Switch>
        <UserList limit={6} filter="flirts" title="topFlirts" />
      </StyledFlirt>
    )
  }
}

const mapStateToProps = ({ flirt, myProfile, account }) => ({
  ...flirt,
  upgraded: isGold(myProfile),
  noPhoto: myProfile.media[0].uri.match(/nophoto/),
  intro: account.intro,
})

const ConnectedFlirt = connect(mapStateToProps, { fetchFlirts, flirtWith, flirtSkip, finishIntro })(Flirt)

export default ConnectedFlirt
